import * as types from './constants';

const initialState = {
  data: {},
  addLoading: false,
  errors_api: {}
};

const actions = {
  // Create Regularusers Group
  [types.CREATE_REGULARUSERS_GROUP_REQUEST]: state => {
    const data = {
      ...state,
      addLoading: true
    };

    return { ...data };
  },

  [types.CREATE_REGULARUSERS_GROUP_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      addLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.CREATE_REGULARUSERS_GROUP_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      addLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

